const pt = String(localStorage.getItem("pt"));


const DocMenuConfig: object = [
  {
    heading: "mainmenu",
    pages: [
      {
        heading: "dashboard",
        route: "/dashboard/reminderspage",
        svgIcon: "media/icons/duotone/Home/Home.svg",
        fontIcon: "bi-app-indicator"
      },
      {
        heading: "leaderboard",
        route: "/leaderboard/top-earner",
        svgIcon: "media/icons/duotone/Shopping/Chart-line1.svg",
        fontIcon: "bi-trophy"
      },
      {
        sectionTitle: "earnings",
        route: "/earnings",
        svgIcon: "media/icons/duotone/Shopping/Wallet.svg",
        fontIcon: "bi-layers",
        sub: [
          {
            heading: "transactions",
            route: "/transactions",
            svgIcon: "media/icons/duotone/Files/Selected-file.svg",
            fontIcon: "bi-layers"
          },
          {
            heading: "encashment",
            route: "/encashment",
            svgIcon: "media/icons/duotone/Shopping/Money.svg",
            fontIcon: "bi-layers"
          },
          {
            heading: "stairstep",
            route: "/stairstep",
            svgIcon: "media/icons/duotone/Home/Stairs.svg",
            fontIcon: "bi-layers"
          },
          {
            heading: "unilevel",
            route: "/unilevel",
            svgIcon: "media/icons/duotone/Interface/Line-03-Up.svg",
            fontIcon: "bi-layers"
          },
          {
            heading: "upp",
            route: "/upp",
            svgIcon: "media/icons/duotone/General/Thunder.svg",
            fontIcon: "bi-layers"
          },
          {
            heading: "myrebates",
            route: "/myrebates",
            svgIcon: "media/icons/duotone/Shopping/Ticket.svg",
            fontIcon: "bi-layers"
          },
          {
            heading: "BIBO Commissions",
            route: "/bibo",
            svgIcon: "media/icons/duotone/Devices/Phone.svg",
            fontIcon: "bi-layers"
          },
          {
            heading: "PCP",
            route: "/pcp_retailers",
            svgIcon: "media/icons/duotone/Shopping/Box3.svg",
            fontIcon: "bi-layers",
            condition: "pcp",
            badge: "reposition"
          }
        ]
      },
      {
        sectionTitle: "networkmenu",
        route: "/networkmenu",
        svgIcon: "media/icons/duotone/Design/Triangle.svg",
        fontIcon: "bi-archive",
        sub: [
          {
            heading: "genealogy",
            route: "/networkmenu/genealogy/",
            svgIcon: "media/icons/duotone/Design/Triangle.svg",
            fontIcon: "bi-archive",
            condition: "notBibo"
          },
          {
            heading: "ppssetup",
            route: "/networkmenu/ppssetup/",
            svgIcon: "media/icons/duotone/Design/Component.svg",
            fontIcon: "bi-archive",
            condition: "notBibo"
          },
          {
            heading: "BIBO Placement",
            route: "/biboendorsers",
            svgIcon: "media/icons/duotone/Communication/Shield-user.svg",
            fontIcon: "bi-layers"
          },
          {
            heading: (pt === "ovi" ? "Digital Partners" : "recruitments"),
            route: "/recruitments",
            svgIcon: "media/icons/duotone/Communication/Add-user.svg",
            fontIcon: "bi-layers"
          },
          {
            heading: "directsponsored",
            route: "/directsponsored",
            svgIcon: "media/icons/duotone/Communication/Group.svg",
            fontIcon: "bi-layers"
          }
        ]
      },
      {
        sectionTitle: "onlineshop",
        route: "/onlineshop",
        svgIcon: "media/icons/duotone/Shopping/Bag2.svg",
        fontIcon: "bi-layers",
        sub: [
          {
            heading: "estore",
            route: "/estore",
            svgIcon: "media/icons/duotone/Shopping/Bag2.svg",
            fontIcon: "bi-layers"
          },
          {
            heading: "reorder",
            route: "/reorder",
            svgIcon: "media/icons/duotone/Shopping/Settings.svg",
            fontIcon: "bi-layers"
          },
          {
            heading: "productgc",
            route: "/productgc",
            svgIcon: "media/icons/duotone/Shopping/Gift.svg",
            fontIcon: "bi-layers"
          },
          {
            heading: "shopcodes",
            route: "/onlineshop/shopcodes/",
            svgIcon: "media/icons/duotone/Shopping/Cart1.svg",
            fontIcon: "bi-archive"
          },
          {
            heading: "shopproducts",
            route: "/onlineshop/shopproducts/",
            svgIcon: "media/icons/duotone/Shopping/Bag2.svg",
            fontIcon: "bi-archive",
            condition: "ccode0"
          },
          {
            heading: "shoppurchases",
            route: "/onlineshop/shoppurchases/",
            svgIcon: "media/icons/duotone/Shopping/Price1.svg",
            fontIcon: "bi-archive"
          },
          {
            heading: "retailsales",
            route: "/onlineshop/retailsales/",
            svgIcon: "media/icons/duotone/Shopping/Sale2.svg",
            fontIcon: "bi-archive"
          },
          {
            heading: "ecwallet",
            route: "/onlineshop/ecwallet/",
            svgIcon: "media/icons/duotone/Shopping/Wallet.svg",
            fontIcon: "bi-archive"
          },
          {
            heading: "mgpay",
            route: "/mgpay",
            svgIcon: "media/icons/duotone/Shopping/Credit-card.svg",
            fontIcon: "bi-archive",
            condition: "ccode0"
          }
        ]
      }
    ]
  },
  {
    heading: "settings",
    route: "/settings",
    pages: [
      {
        heading: "profile",
        route: "/settings/profile/",
        svgIcon: "media/icons/duotone/General/User.svg",
        fontIcon: "bi-archive"
      }, 
      {
        heading: "Leader's Toolkit",
        route: "/settings/team-materials/",
        svgIcon: "media/icons/duotone/Files/Folder.svg",
        fontIcon: "bi-folder"
      },
      {
        heading: "ai247",
        route: "/settings/ai247-portal/",
        svgIcon: "media/icons/duotone/Communication/Address-card.svg",
        fontIcon: "bi-building",
        badge: "inboxUnread"
      },
      {
        heading: "sites",
        route: "/sites",
        svgIcon: "media/icons/duotone/Design/Sketch.svg",
        fontIcon: "bi-globe",
        condition: "sitesPreview"
      },
      {
        heading: "autopma",
        route: "/autopma",
        svgIcon: "media/icons/duotone/Design/Edit.svg",
        fontIcon: "bi-layers",
        condition: "autopma"
      },
      {
        heading: "Override",
        route: "/override/",
        svgIcon: "media/icons/duotone/Communication/Shield-user.svg",
        fontIcon: "bi-shield",
        condition: "override"
      },
      {
        heading: "Log-out",
        route: "/logout",
        svgIcon: "media/icons/duotone/Navigation/Sign-out.svg",
        fontIcon: "bi-archive"
      }
    ]
  },
];

export default DocMenuConfig;
